module.exports = "/_next/static/images/Mockups-0a77e712df5035072cbb3f07f6e1d9fa.png";